/* Steelmonks Warenkorb: das personalisierte Schild als Zeilenbild in Drawer und Warenkorbseite.
   Welche Zeilen: snippets/sm-cart-line-details.liquid setzt <i hidden data-sm-ks="{h, o, p}"> (Handle, options_with_values, properties) an
     Zeilen mit unserem Link _Vorschau (https://steelmonks.com/products/…?view=schild…) und an Zeilen aus hausschilder, strassenschilder, hausnummern
     mit Personalisierung, aber ohne eigenes Zepto-Bild (_pplr_preview). Zeilen mit Zepto-Bild behalten es.
   Was gezeichnet wird: die sichtbaren Eigenschaften der Zeile, alte Zepto-Schlüssel („<b>Straßenname<b>“) und neue („Straßenname“) gleich, mit
     sm-schild.js (SMSchild) in Oberfläche und Größe der Variante, so wie die neue Produktseite (assets/sm-pdp.js, miniNah): Nahansicht der Hauswand,
     das Schild füllt das Quadrat. Je Zeichen eine Zeile (Hausnummer Auswahl) zeigt ihr eigenes Zeichen.
   Nie ein falsches Bild: ist etwas unbekannt (Feld, Auswahlwert, Oberfläche, Zeichen ohne Glyphe) oder geht etwas schief (Skript, Schrift, Textur),
     bleibt das Produktbild. Gleiche Größe und Form wie das Zeilenbild: die Ebene liegt über dem img in td.cart-item__media.
   Schnell: dieses Skript ist klein; sm-schild.js, sm-ss-designs.json, Schriften und Texturen lädt es nur, wenn eine solche Zeile zu sehen ist
     (Warenkorbseite beim Laden, Drawer beim Öffnen, neue Zeilen im offenen Drawer; vorab, wenn der Zeiger auf das Warenkorb-Symbol geht).
     Gezeichnete Zeilen merkt es sich: nach jedem Neuaufbau von Drawer oder Warenkorbseite (innerHTML) steht das Bild sofort wieder da.
   Als Rasterbild: das SVG des Schilds (mit Texturen und Formen als data-URL eingebettet) wird einmal je Zeile auf eine Leinwand gezeichnet
     (längste Seite 300 px) und als PNG eingesetzt, als Hintergrund eines span: ein img in der Zelle bekäme die Regeln
     von sm-cart.css für das Zeilenbild (72 px, object-fit cover, !important) und stünde zu groß da. Ein SVG mit Textur-Mustern im Dokument meldete Chrome als größtes Element (LCP) der
     Warenkorbseite, mit der Fläche der Textur statt der 72 px des Bilds (Messung 20.10.2026: LCP 6,2 s statt 1,1 s am gedrosselten Handy).
     Klappt das Rastern nicht (alter Browser, Ladefehler), steht das SVG wie bisher da. */
(function () {
  'use strict';
  var W = typeof window !== 'undefined' ? window : this;
  if (W.SMKorbSchild) return;

  /* ---------- 1. Reine Regeln (auch in node prüfbar) ---------- */
  // Feldname ohne Auszeichnung, wie im Warenkorb-Vertrag v2: Tags weg, &#44; wird Komma, Leerzeichen am Rand weg, führende - und _ weg
  function sauber(k) {
    return String(k == null ? '' : k).replace(/<[^>]*>/g, '').replace(/&#44;/g, ',').trim().replace(/^[-_]+/, '').trim();
  }
  function hat(o, k) { return k != null && Object.prototype.hasOwnProperty.call(o || {}, k); }
  // Liquid gibt Eigenschaften als [[Schlüssel, Wert], …] aus, Schlüssel schon ohne Tags, Werte HTML-maskiert (&amp;); /cart.js als Objekt mit Rohwerten
  var ENT = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };
  function roh(s) {
    return String(s == null ? '' : s).replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, function (m, e) {
      if (e.charAt(0) === '#') { var n = e.charAt(1).toLowerCase() === 'x' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10); return n > 0 && n < 0x110000 ? String.fromCodePoint(n) : m; }
      return hat(ENT, e.toLowerCase()) ? ENT[e.toLowerCase()] : m;
    });
  }
  function paare(P) {
    if (Array.isArray(P)) return P.filter(function (x) { return x && x.length === 2; }).map(function (x) { return [roh(x[0]), x[1] == null ? null : roh(x[1])]; });
    return Object.keys(P || {}).map(function (k) { return [k, P[k]]; });
  }
  function r2(x) { return Math.round(x * 100) / 100; }
  var NRNAME = /^(haus)?nummer( oder text| auswahl)?$/i, TEXTNAME = /stra(ß|ss)e|name|wunschtext|adresse/i;
  var GROESSEN = ['Breite', 'Höhe', 'Durchmesser', 'Größe', 'Länge'];
  function opt(L, n) {
    var o = (L.o || []).filter(function (x) { return x && x.name === n; })[0];
    return o && o.value != null ? String(o.value) : null;
  }
  // Eingabe für SMSchild.zeichne aus den sichtbaren Eigenschaften der Zeile, je Feld des Designs (eingabe.werte). null: nicht sicher zu zeichnen.
  // Nummernfelder (Feldname des Designs sm.nr oder Hausnummer, Nummer, Hausnummer oder Text, Hausnummer Auswahl) gehen ins Nummernfeld,
  // Textfelder der Reihe nach in die Textfelder des Designs (3-zeiliges Schild: Straßenname, dann Familienname; Doppelnamen: oben, dann unten).
  // Auswahlfelder, die die Zeichnung ändern (Farbe, Band Farbe, Deine Kreation, Zunftzeichen), nur mit einem Wert, den das Design kennt.
  // Befestigung zeichnet nichts. Feste Angaben des Designs (Emaille: Schriftart) müssen stimmen.
  function eingabe(d, L) {
    var sm = d.sm || {}, lab = {}, wn = {}, fest = {}, nr = [], tx = [], mono = null, wahl = {}, nein = false, k;
    ['nr', 'st', 'txt', 'mono'].forEach(function (r) { if (sm[r]) lab[sauber(sm[r])] = r; });
    if (d.farbe && d.farbe.sm) wn[sauber(d.farbe.sm)] = { n: d.farbe.sm, ok: d.farbe.wahl || {} };
    if (sm.paar && d.paare) wn[sauber(sm.paar)] = { n: sm.paar, ok: d.paare.reduce(function (o, x) { o[x.name] = 1; return o; }, {}) };
    for (k in d.wahl || {}) wn[sauber(k)] = { n: k, ok: d.wahl[k].opt || {} };
    for (k in d.fest || {}) fest[sauber(k)] = String(d.fest[k]);
    paare(L.p).forEach(function (kv) {
      var key = kv[0], w = kv[1], s, x;
      if (key.charAt(0) === '_' || w == null) return;
      w = String(w).replace(/\r\n?/g, '\n').trim();
      if (!w) return;
      s = sauber(key); x = wn[s];
      if (/^befestigung/i.test(s)) return;
      if (x) { if (hat(x.ok, w)) wahl[x.n] = w; else nein = true; return; }
      if (hat(fest, s)) { if (w !== fest[s]) nein = true; return; }
      if (lab[s] === 'mono') { mono = w; return; }
      if (lab[s] === 'nr' || (!lab[s] && NRNAME.test(s))) { nr.push(w); return; }
      if (lab[s] === 'st' || lab[s] === 'txt' || TEXTNAME.test(s)) { tx.push(w); return; }
      nein = true;
    });
    if (nein || nr.length > 1 || (!nr.length && !tx.length) || (d.mono && !mono)) return null;
    var tp = d.props.filter(function (p) { return p.role !== 'nr'; }), np = d.props.filter(function (p) { return p.role === 'nr'; }), v = {};
    if (tx.length > tp.length) return null;
    d.props.forEach(function (p) { v[p.prop] = ''; });
    tx.forEach(function (t, i) { v[tp[i].prop] = t; });
    if (nr.length) {
      if (np.length) v[np[0].prop] = nr[0];
      else if (tp.length) v[tp[0].prop] = (v[tp[0].prop] + ' ' + nr[0]).trim();
      else return null;
    }
    var e = { werte: v };
    if (mono != null) e.mono = mono;
    for (k in wahl) { e.wahl = wahl; break; }
    return e;
  }
  // Größe: Wert der Größen-Option des Designs (d.opt), sonst der ersten Option Breite, Höhe, Durchmesser, Größe, Länge (wie sm-pdp.js grName)
  function groesse(d, L) {
    if (d.opt && opt(L, d.opt) != null) return opt(L, d.opt);
    for (var i = 0; i < GROESSEN.length; i++) if (opt(L, GROESSEN[i]) != null) return opt(L, GROESSEN[i]);
    return '';
  }
  // Oberfläche wie sm-pdp.js flaeche(): o für das Schild, wo für die Wand. Unbekannte Oberfläche: null (dann kein Bild statt Schwarz geraten)
  function flaeche(S, d, L) {
    var of = opt(L, 'Oberfläche'), o = 0, wo;
    if (of != null) { o = S.surfaceIndex(of); if (o < 0) return null; }
    if (d.emaille) o = 0;
    if (of == null && d.flaeche > 0 && !d.hinten) o = d.flaeche;
    wo = o;
    if (of == null && d.hinten && !d.emaille) { wo = d.hinten.surface || 0; o = d.flaeche > 0 ? d.flaeche : wo === 2 ? 0 : 2; }
    if (wo === 5) wo = 4;
    return { o: o, wo: wo };
  }
  // Ergebnis für eine Zeile: {i (Wand 0 hell, 1 dunkel), bg, size, pos (Hintergrund), box (Kasten des Schilds in %), f (Vergrößerung), o2, svg} oder null
  function bild(S, d, L, haus) {
    var e = eingabe(d, L), F = e && flaeche(S, d, L);
    if (!e || !F) return null;
    var Q = S.zeichne(d, e, groesse(d, L) || undefined);
    if (!Q || Q.leer || (Q.bad && Q.bad.length) || !(Q.white || Q.farbig)) return null;
    var o = Q.vorn != null ? Q.vorn : F.o, r = { o2: o === 2, svg: S.svg(Q, o) }, Z = S.szene(Q, F.wo), Lu, a, w, h;
    if (Z) {
      Lu = S.lupe(Z, { w: 100, h: 100, fx: 0.9, fy: 0.7 });
      r.i = Z.i; r.bg = haus ? haus[Z.i] : ''; r.size = Lu.size; r.pos = Lu.pos; r.box = Lu.box; r.f = Lu.f; r.Z = Z;
    } else {   // ohne Maßstab (keine Größe): eingepasst auf ruhiger Fläche
      a = (Q.x1 - Q.x0) / ((Q.y1 - Q.y0) || 1); w = 0.9; h = w / a;
      if (h > 0.7) { h = 0.7; w = h * a; }
      r.i = S.wandIndex(Q.hinten ? Q.hinten.surface : F.wo); r.bg = ''; r.f = 0;
      r.box = { left: r2((1 - w) * 50), top: r2((1 - h) * 50), width: r2(w * 100), height: r2(h * 100) };
    }
    return r;
  }
  var API = { sauber: sauber, eingabe: eingabe, groesse: groesse, flaeche: flaeche, bild: bild };
  W.SMKorbSchild = API;

  /* ---------- 2. Seite ---------- */
  var D = W.document, me = D && D.currentScript;
  if (!me || !me.dataset || !me.dataset.js || !me.dataset.asset || !W.MutationObserver || !W.Promise) return;
  var A = me.dataset.asset, JSU = me.dataset.js, VER = me.dataset.ver;
  var TEX = ['schwarz', 'anthrazit', 'edelstahl', 'corten', 'weiss', 'gold'].map(function (n) { return A + 'sm-ss-tex-' + n + '.jpg'; });
  var HAUS = [A + 'sm-ss-haus-1.jpg', A + 'sm-ss-haus-2.jpg'];
  var S = null, SJS = null, FERTIG = {}, RECHNET = {}, BILDER = {}, KZ = 0, STIL = false;

  function css() {
    if (STIL) return; STIL = true;
    var s = D.createElement('style'); s.id = 'sm-korb-schild-css';
    s.textContent =
      '.smks-td{position:relative}' +
      '.smks{position:absolute;left:0;top:0;z-index:1;display:block;width:100%;aspect-ratio:1/1;border-radius:12px;overflow:hidden;pointer-events:none;background-repeat:no-repeat;background-color:#cfcdc8}' +
      '.smks.smks-w1{background-color:#33363a;--s1:.6;--s2:.36}' +
      '.smks::after{content:"";position:absolute;inset:0;border-radius:inherit;background:radial-gradient(70% 80% at 50% 42%,rgba(255,255,255,.13),rgba(255,255,255,0) 70%),linear-gradient(180deg,rgba(0,0,0,0) 55%,rgba(0,0,0,.08));box-shadow:inset 0 0 0 1px rgba(11,12,14,.06)}' +
      '.smks-auf{position:absolute;display:block}' +
      '.smks-r{background:center/contain no-repeat}' +
      '.smks-auf svg,.smks-auf .smks-r{display:block;width:100%;height:100%;overflow:visible;filter:var(--vf,brightness(1)) drop-shadow(calc(var(--c,1px)*.14) calc(var(--c,1px)*.55) calc(var(--c,1px)*.2) rgba(0,0,0,var(--s1,.46))) drop-shadow(calc(var(--c,1px)*.3) calc(var(--c,1px)*1.4) calc(var(--c,1px)*1) rgba(0,0,0,var(--s2,.24)))}' +
      '.smks.smks-w1.smks-o2{--vf:brightness(1.12) contrast(1.04)}' +
      '.smks-neu{animation:smks-ein .22s ease-out both}@keyframes smks-ein{from{opacity:0}to{opacity:1}}' +
      '@media (prefers-reduced-motion:reduce){.smks-neu{animation:none}}';
    D.head.appendChild(s);
  }
  // sm-schild.js nur einmal: vorhandenes SMSchild nehmen oder auf ein schon eingefügtes Skript warten (Produktseite, Werkstatt), sonst selbst laden.
  // Fremdes SMSchild nicht neu einrichten (dessen Texturen und Version bleiben); nur wenn es noch nicht eingerichtet ist, scheitert load, dann init
  var CFG = { asset: A, tex: TEX, deco: { ornament: A + 'sm-ss-ornament.png', katze: A + 'sm-ss-katze.png' }, ver: VER };
  function schildJs() {
    if (SJS) return SJS;
    var eigen = false;
    SJS = new Promise(function (ok, no) {
      if (W.SMSchild) return ok(W.SMSchild);
      var alt = D.querySelector('script[src*="/sm-schild.js"]'), s = alt || D.createElement('script'), t = setTimeout(function () { no(new Error('sm-schild.js lädt nicht')); }, 15000);
      s.addEventListener('load', function () { clearTimeout(t); if (W.SMSchild) ok(W.SMSchild); else no(new Error('SMSchild fehlt')); });
      s.addEventListener('error', function () { clearTimeout(t); no(new Error('sm-schild.js')); });
      if (!alt) { eigen = true; s.src = JSU; s.async = true; D.head.appendChild(s); }
    }).then(function (X) {
      S = X;
      if (eigen) S.init(CFG);
      return S;
    });
    return SJS;
  }
  function laden(nur) {
    return schildJs().then(function () {
      return S.load(nur).then(null, function () { S.init(CFG); return S.load(nur); });
    });
  }
  // Bilder (Wand, Texturen, Formen) vorher laden: ein SVG-Muster ohne geladene Textur bliebe leer. Fehlt eins, bleibt das Produktbild
  function vorladen(u) {
    if (!BILDER[u]) BILDER[u] = new Promise(function (ok, no) {
      var i = new Image(), t = setTimeout(function () { no(new Error('Zeit ' + u)); }, 8000);
      i.onload = function () { clearTimeout(t); ok(); }; i.onerror = function () { clearTimeout(t); no(new Error(u)); };
      i.src = u;
    });
    return BILDER[u];
  }
  // Datei als data-URL (für das SVG im img: ein SVG-Bild lädt keine fremden Dateien nach). Gleiche Herkunft (/cdn/shop/t/…/assets/)
  var DATEN = {};
  function daten(u) {
    if (!DATEN[u]) DATEN[u] = fetch(u, { credentials: 'same-origin' }).then(function (x) {
      if (!x.ok) throw new Error(u + ' ' + x.status);
      return x.blob();
    }).then(function (b) {
      return new Promise(function (ok, no) { var f = new FileReader(); f.onload = function () { ok(f.result); }; f.onerror = function () { no(new Error('lesen ' + u)); }; f.readAsDataURL(b); });
    });
    return DATEN[u];
  }
  // SVG des Schilds als PNG (object URL). Längste Seite 300 px: reicht für das Zeilenbild (bis etwa 100 px) bei dreifacher Pixeldichte
  function raster(r) {
    if (!W.fetch || !W.FileReader || !W.URL || !URL.createObjectURL || !W.HTMLCanvasElement || !HTMLCanvasElement.prototype.toBlob) return Promise.reject(new Error('kein Rastern'));
    var vb = /viewBox="([-\d.e]+) ([-\d.e]+) ([\d.e]+) ([\d.e]+)"/.exec(r.svg), u = urls({ svg: r.svg });
    if (!vb || !(+vb[3] > 0) || !(+vb[4] > 0)) return Promise.reject(new Error('viewBox'));
    var a = +vb[3] / +vb[4], w = a >= 1 ? 300 : Math.max(1, Math.round(300 * a)), h = a >= 1 ? Math.max(1, Math.round(300 / a)) : 300;
    return Promise.all(u.map(daten)).then(function (d) {
      var t = r.svg;
      u.forEach(function (x, i) { t = t.split('href="' + x.replace(/&/g, '&amp;') + '"').join('href="' + d[i] + '"').split('href="' + x + '"').join('href="' + d[i] + '"'); });
      t = t.replace(/^<svg /, '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" ');
      var su = URL.createObjectURL(new Blob([t], { type: 'image/svg+xml' }));
      return new Promise(function (ok, no) {
        var i = new Image(), z = setTimeout(function () { no(new Error('Zeit Rastern')); }, 8000);
        i.onload = function () { clearTimeout(z); ok(i); }; i.onerror = function () { clearTimeout(z); no(new Error('SVG lädt nicht')); };
        i.src = su;
      }).then(function (i) {
        var c = D.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(i, 0, 0, w, h);
        URL.revokeObjectURL(su);
        return new Promise(function (ok, no) { c.toBlob(function (b) { if (b) ok(URL.createObjectURL(b)); else no(new Error('toBlob')); }, 'image/png'); });
      }, function (e) { URL.revokeObjectURL(su); throw e; });
    });
  }
  function urls(r) {
    var l = r.bg ? [r.bg] : [], m, re = /href="([^"]+)"/g;
    while ((m = re.exec(r.svg))) if (!/^(data:|#)/.test(m[1]) && l.indexOf(m[1]) < 0) l.push(m[1].replace(/&amp;/g, '&'));
    return l;
  }
  function zelle(el) { var tr = el.closest('.cart-item'); return tr && tr.querySelector('.cart-item__media'); }
  // Die Ebene deckt genau das Zeilenbild (img): gleiche Lage, Größe und Rundung. Die Zelle kann breiter sein als das Bild (Warenkorbseite am Rechner:
  // td 96 px, img 72 px, weil sm-cart.css beides mit !important setzt). Ohne Bild: Quadrat in Zellenbreite
  function kasten(el, td, r) {
    var img = td.querySelector('img'), w = img && img.offsetWidth, h = img && img.offsetHeight, L = r.Z && S ? S.lupe(r.Z, { w: 100, h: w && h ? 100 * h / w : 100, fx: 0.9, fy: 0.7 }) : r, b = L.box, a = el.firstChild;
    if (w && h) {
      el.style.left = img.offsetLeft + 'px'; el.style.top = img.offsetTop + 'px'; el.style.width = w + 'px'; el.style.height = h + 'px';
      el.style.borderRadius = getComputedStyle(img).borderRadius;
    }
    if (r.bg) { el.style.backgroundSize = L.size; el.style.backgroundPosition = L.pos; }
    el.style.setProperty('--c', ((w || td.clientWidth || 72) / 250 * (L.f || 1)).toFixed(3) + 'px');
    if (a) { a.style.left = b.left + '%'; a.style.top = b.top + '%'; a.style.width = b.width + '%'; a.style.height = b.height + '%'; }
  }
  function einsetzen(td, r, sig, neu) {
    var alt = td.querySelectorAll('.smks'), k = ++KZ, el = D.createElement('span');
    for (var i = 0; i < alt.length; i++) alt[i].parentNode.removeChild(alt[i]);
    el.className = 'smks smks-w' + r.i + (r.o2 ? ' smks-o2' : '') + (neu ? ' smks-neu' : '');
    el.setAttribute('aria-hidden', 'true');
    if (r.bg) el.style.backgroundImage = 'url("' + r.bg + '")';
    // Rasterbild, sonst SVG mit eigenen IDs je Stelle (Muster, Masken): dieselbe ID zweimal in der Seite (Drawer und Warenkorbseite) zeigte sonst auf das erste Vorkommen
    el.innerHTML = '<span class="smks-auf">' + (r.png ? '<i class="smks-r" style="background-image:url(&quot;' + r.png + '&quot;)"></i>' : r.svg.replace(/\b(sms[ceg]\d+)/g, '$1k' + k)) + '</span>';
    el.__smks = r;
    td.classList.add('smks-td');   // Bezug für die Ebene; component-cart-items.css (position: relative) gibt es nur auf der Warenkorbseite
    td.appendChild(el);
    kasten(el, td, r);
    td.setAttribute('data-sm-ks-an', sig);
  }
  // Zeilen mit fertigem Ergebnis sofort einsetzen (auch im MutationObserver, vor dem nächsten Bild); gibt die Zeilen zurück, die noch zu rechnen sind
  function sofort() {
    var els = D.querySelectorAll('[data-sm-ks]'), offen = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i], sig = el.getAttribute('data-sm-ks'), td = zelle(el);
      if (!td || (td.getAttribute('data-sm-ks-an') === sig && td.querySelector('.smks'))) continue;
      if (hat(FERTIG, sig)) { if (FERTIG[sig]) einsetzen(td, FERTIG[sig], sig, false); else td.removeAttribute('data-sm-ks-an'); }
      else offen.push({ sig: sig, el: el });
    }
    return offen;
  }
  function zeichnen() {
    var offen = sofort();
    if (!offen.length) return Promise.resolve();
    css();
    var Ls = [], hs = {};
    offen.forEach(function (x) {
      if (RECHNET[x.sig]) return;
      var L = null;
      try { L = JSON.parse(x.sig); } catch (e) { L = null; }
      if (!L || !L.h) { FERTIG[x.sig] = null; return; }
      Ls.push({ sig: x.sig, L: L }); hs[L.h] = 1;
    });
    if (!Ls.length) return Promise.resolve();
    var geladen = laden(function (d) { return !!hs[d.handle]; });
    Ls.forEach(function (x) {
      RECHNET[x.sig] = geladen.then(function () {
        var d = S.get(x.L.h), r = d && S.ready(d) ? bild(S, d, x.L, HAUS) : null;
        if (!r) return null;
        return Promise.all(urls(r).map(vorladen)).then(function () {
          return raster(r).then(function (png) {
            r.png = png;
            // Fertig dekodiert einsetzen, damit die Ebene nicht leer aufblendet
            var i = new Image(); i.src = png;
            return (i.decode ? i.decode() : Promise.resolve()).then(function () { return r; }, function () { return r; });
          }, function (e) { if (W.console) console.warn('Warenkorb-Schild als SVG:', (e && e.message) || e); return r; });
        });
      }).then(null, function (e) {
        if (W.console) console.warn('Warenkorb-Schild:', (e && e.message) || e);
        return null;
      }).then(function (r) {
        FERTIG[x.sig] = r || null;
        var els = D.querySelectorAll('[data-sm-ks]');
        for (var i = 0; i < els.length; i++) {
          if (els[i].getAttribute('data-sm-ks') !== x.sig || !r) continue;
          var td = zelle(els[i]);
          if (td && !(td.getAttribute('data-sm-ks-an') === x.sig && td.querySelector('.smks'))) einsetzen(td, r, x.sig, true);
        }
      });
    });
    return Promise.all(Ls.map(function (x) { return RECHNET[x.sig]; }));
  }

  // Neu vermessen, wenn sich die Bildgröße ändern kann (Fensterbreite über 749 px, Drawer geöffnet)
  function messen(root) { [].forEach.call((root || D).querySelectorAll('.smks'), function (el) { if (el.__smks && el.parentNode) kasten(el, el.parentNode, el.__smks); }); }
  var RT = 0;
  W.addEventListener('resize', function () { clearTimeout(RT); RT = setTimeout(function () { messen(); }, 150); });

  var drawer = D.querySelector('cart-drawer');
  function aktiv() { return !!(drawer && drawer.classList.contains('active')); }
  function seite() { return !!D.getElementById('main-cart-items'); }
  function hatZeilen(root) { return !!(root || D).querySelector('[data-sm-ks]'); }
  // Warenkorbseite: gleich. Drawer: beim Öffnen (Dawn setzt active) oder vorab, wenn der Zeiger auf das Warenkorb-Symbol geht
  if (seite() && hatZeilen()) zeichnen();
  else if (aktiv() && hatZeilen(drawer)) zeichnen();
  if (drawer) new MutationObserver(function () { if (aktiv() && hatZeilen(drawer)) { messen(drawer); zeichnen(); } }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  var icon = D.getElementById('cart-icon-bubble');
  if (icon && drawer) ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
    icon.addEventListener(ev, function () { if (hatZeilen(drawer)) zeichnen(); }, { passive: true, once: true });
  });
  // Neuaufbau (applySections, renderContents, onCartUpdate, updateQuantity): fertige Bilder sofort, neue Zeilen rechnen, wenn sie zu sehen sind
  new MutationObserver(function (rs) {
    for (var i = 0; i < rs.length; i++) {
      var n = rs[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        var x = n[j];
        if (x.nodeType === 1 && (x.hasAttribute('data-sm-ks') || x.querySelector('[data-sm-ks]'))) {
          if (S || seite() || aktiv()) zeichnen(); else sofort();
          return;
        }
      }
    }
  }).observe(D.body || D.documentElement, { childList: true, subtree: true });
})();
